var __jsx = React.createElement;
import React from "react";
import useIsMobile from "@hooks/useIsMobile";
import Loader from "@componentsShared/Loader/Loader";
import stl from "./MobileDesktopButton.module.css";
import { twMerge } from "tailwind-merge";
import { If } from "@componentsShared/Conditional/If";
var MobileDesktopButton = function MobileDesktopButton(_ref) {
  var onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isSubmitting = _ref.isSubmitting,
    isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "fixed bottom-0 left-0 z-[1] flex justify-between items-center w-full bg-white px-4 pt-5 pb-7 text-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end w-full"
    }, /*#__PURE__*/React.createElement("button", {
      className: twMerge("blueBtn py-3 px-3 w-full h-14 flex justify-center items-center rounded-sm", className),
      onClick: onClick,
      disabled: disabled || isSubmitting
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-center font-bold text-[16px]"
    }, children), /*#__PURE__*/React.createElement(If, {
      condition: isSubmitting
    }, /*#__PURE__*/React.createElement(Loader, {
      smallLoader: true,
      className: stl.btnLoading
    })))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: stl.submitData
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("blueBtn", className),
    onClick: onClick,
    disabled: disabled || isSubmitting
  }, /*#__PURE__*/React.createElement("strong", null, children), /*#__PURE__*/React.createElement("span", null), isSubmitting && /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: stl.btnLoading
  })));
};
export default MobileDesktopButton;